module.exports = __webpack_public_path__ + "img/new-logo.5e5f5955.svg";